import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Error.module.scss';
import Button from '../../components/button/Button';

const Error = () => {
	return (
		<div className={styles.root}>
			<div className={styles.container}>
				<h2 className={styles.heading}>404</h2>
				<h3>Oops! Page not found</h3>
				<Button>
					<Link to="/" className={styles.link}>
						Go back home
					</Link>
				</Button>
			</div>
		</div>
	);
};

export default Error;
